import type { Project } from "../pages/ProjectsPage";

export const projects: Project[] = [
  {
    id: 1,
    name: "Hotpot VR",
    video: "https://youtu.be/bA2FPyFT_18",
    description:
      "An immersive VR cooking simulation with realistic boiling water, dynamic ingredient interactions, and an AI cousin.",
    contributions: [
      "Implemented boiling water physics using fluid simulation with buoyancy including heat and water control, and a custom water shader with Shader Graph",
      "Designed realistic smoke and bubbling effects",
      "Created menu design and recorded voicelines",
    ],
    tools: ["Unity", "C#", "XR Toolkit", "Shader Graph"],
    demo: "https://youtu.be/bA2FPyFT_18",
    category: "Games",
  },
  {
    id: 2,
    name: "Mini-Minecraft",
    video: "https://vimeo.com/1052431663?share=copy",
    description:
      "A Minecraft-inspired 3D game featuring procedural terrain generation, player physics, and custom water shaders.",
    contributions: [
      "A group project with a total of 3 people",
      "Implemented player physics, including smooth collision detection (using ray marching) and physics-based movement including swimming",
      "3D perlin noise to form caves, post-process shaders for lava and water",
      "Created a realistic water shader, using a displacement map, parallax mapping, Blinn-Phone refleciton model with fresnel to simulate how light reflects off the surface, and blended the water's appearance with the sky code. Reflection and refraction textures were also sampled to add realism.",
      "Additionally added noise, crosshair, and additional biomes using bilinear interpolation.",
    ],
    tools: ["OpenGL", "C++", "GLSL"],
    demo: "https://vimeo.com/1052431663?share=copy",
    category: "Computer Graphics",
  },
  {
    id: 3,
    name: "PBR Shader and SDF Model",
    video: "https://youtu.be/b4yH-FlUmEs",
    description:
      "An OpenGL Shader with plastic/metallic BRDFs and pre-computed irradiance.",
    contributions: [
      "Created a raymarched Signed Distance Field model of an animated Togepi and Voltorb, which is integrated into the PBR pipeline",
    ],
    tools: ["OpenGL", "C++", "GLSL"],
    demo: "https://youtu.be/b4yH-FlUmEs",
    category: "Rendering",
  },
  {
    id: 4,
    name: "Mini-Maya",
    video: "https://youtu.be/BrQ1H4bIxw4",
    description:
      "Built a custom mesh editor using a half-edge data structure, enabling mesh manipulation, smoothing, and visualization with real-time OpenGL rendering.",
    contributions: [
      "Modify mesh topology to add vertices, triangulating faces, changing vertex and face colors, using Catmull-Clark subdivision for mesh smoothing and extruding face",
      "Obj importer and parser",
    ],
    tools: ["OpenGL", "C++", "GLSL"],
    demo: "https://youtu.be/BrQ1H4bIxw4",
    category: "Computer Graphics",
  },
  {
    id: 5,
    name: "Extreme Extermination",
    video: "https://youtu.be/fYP_kxwYy1U",
    description:
      "Fast-paced cockroach elimination game involving room destruction and multiple weapons.",
    contributions: [
      "Implemented the main sledgehammer swing mechanic, flamethrower, and twinkie attractant resource",
      "Created and hooked up the main menu UI",
    ],
    tools: ["Unreal Blueprints"],
    demo: "https://youtu.be/fYP_kxwYy1U",
    category: "Games",
  },
  {
    id: 6,
    name: "Pouring Vessel",
    video: "/videos/vase.mp4",
    description: "A detailed 3D model of a pouring vessel crafted using Maya.",
    tools: ["Maya"],
    demo: "/videos/ExtremeExtermination.mp4",
    category: "Models",
  },
  {
    id: 7,
    name: "Attic Nook",
    photos: [
      "/images/projects/env1.png",
      "/images/projects/env2.png",
      "/images/projects/env3.png",
      "/images/projects/env4.png",
      "/images/projects/env5.png",
    ],
    description:
      "A cozy 3D modeled attic environment textured with Substance Painter.",
    tools: ["Maya", "Substance Painter"],
    category: "Models",
  },
  {
    id: 8,
    name: "Physics Invaders",
    video: "https://vimeo.com/1061091021",
    description:
      "A spin on the classic Atari Space Invaders Game, including a boss and new resources.",
    tools: ["Unity", "C#"],
    demo: "https://vimeo.com/1061091021",
    category: "Games",
  },
  {
    id: 8,
    name: "OpenGL Fun",
    video: "https://youtu.be/2LmAHTW10-g",
    description:
      "Implemented various surface shaders to create dynamic visual effects, including vertex deformations and post-processing effects for enhanced graphics realism.",
    contributions: [
      "Implemented shaders for reflections and deformations",
      "Impelmented post-process shaders including Gaussian blur and Sobel",
    ],
    tools: ["C++", "OpenGL", "GLSL"],
    demo: "https://youtu.be/2LmAHTW10-g",
    category: "Computer Graphics",
  },
  {
    id: 9,
    name: "Rasterizer",
    video: "https://youtu.be/1gdbG4X72EU",
    description: "A 2D and 3D rasterization",
    contributions: [
      "2D rasterization including triangulation, pixel row intersection, z-buffering, and barycentric interpolation",
      "3D rasterization using perspective-correct interpolation",
      "Implemented wireframe rendering following Bresenham's line algorithm",
      "Implemented Anti-Aliasing up to 16x for a smoother visual quality",
    ],
    tools: ["C++", "OpenGL"],
    demo: "https://youtu.be/1gdbG4X72EU",
    category: "Computer Graphics",
  },
  {
    id: 10,
    name: "Monte Carlo Path Tracer",
    photos: [
      "/images/projects/mcpt1.png",
      "/images/projects/mcpt2.png",
      "/images/projects/mcpt3.png",
      "/images/projects/mcpt4.png",
      "/images/projects/mcpt5.png",
      "/images/projects/mcpt6.png",
      "/images/projects/mcpt7.png",
      "/images/projects/mcpt8.png",
    ],
    description: "A real-time shader-based path tracer.",
    contributions: [
      "Naive, direct and full lighting integrators with multiple importance sampling",
      "Implemented a variety of material BSDFs including specular, transmissive, microfacets",
      "Implemented screen-space reflection",
    ],
    tools: ["C++", "OpenGL", "GLSL"],
    category: "Rendering",
  },
];
